// extracted by mini-css-extract-plugin
module.exports = {"btns":"ProjectCompletionPopup_btns__2wgMS","suppliers":"ProjectCompletionPopup_suppliers__2TiSd"};